import { DEFAULT_SEGMENT_THICKNESS, SegmentSpec } from "./types";

const MIN_SIDE = 0.01;

export interface ThicknessSides {
  upThickness: number;
  downThickness: number;
  /** up + down */
  thickness: number;
}

/** Persist / legacy → up+down. upThickness yoksa eski symmetric: her iki taraf = thickness. */
export function resolveThicknessSides(raw: {
  thickness?: number;
  upThickness?: number;
  downThickness?: number;
}): ThicknessSides {
  if (raw.upThickness !== undefined && raw.downThickness !== undefined) {
    const up = Math.max(MIN_SIDE, raw.upThickness);
    const down = Math.max(MIN_SIDE, raw.downThickness);
    return { upThickness: up, downThickness: down, thickness: up + down };
  }

  const legacy = raw.thickness ?? DEFAULT_SEGMENT_THICKNESS * 0.5;
  const up = legacy / 2;
  const down = legacy / 2;
  return { upThickness: up, downThickness: down, thickness: up + down };
}

export function thicknessSidesOf(spec: SegmentSpec): ThicknessSides {
  return resolveThicknessSides(spec);
}

export function applyThicknessSides(
  spec: SegmentSpec,
  sides: ThicknessSides,
): void {
  spec.upThickness = Math.max(MIN_SIDE, sides.upThickness);
  spec.downThickness = Math.max(MIN_SIDE, sides.downThickness);
  spec.thickness = spec.upThickness + spec.downThickness;
}

/** Yeni segment — thickness toplam, iki taraf yarı yarıya. */
export function thicknessSidesFromTotal(total: number): ThicknessSides {
  const half = Math.max(MIN_SIDE, total) / 2;
  return { upThickness: half, downThickness: half, thickness: half * 2 };
}
